// Feature announcement ("what's new" splash)
// -------------------------------------------
// A one-time, dismissible full-screen announcement shown to logged-in
// users with a profile. Unlike splashConfig.js (which blocks the whole
// site indefinitely), this is acknowledged once per user and then never
// shown to them again.
//
// To announce something new in future:
// 1. Drop your image in client/public/ (e.g. client/public/announcement-foo.png).
// 2. Update imageSrc/imageAlt/title/message/cta below.
// 3. Change `id` to a new, unique string — this is what "resets" the
//    acknowledgment for every user. Reusing the same id after editing the
//    message will NOT re-show it to people who already dismissed the
//    previous one; bump the id if you want everyone to see it again.
// 4. Set enabled: true.

const announcementConfig = {
  enabled: true,
  id: "last-man-standing-launch",
  imageSrc: "/announcement-last-man-standing.png",
  imageAlt: "Last Man Standing is here",
  title: "New: Last Man Standing",
  message:
    "Pick one Premier League team to win each gameweek. Get it wrong, or pick the same team twice, and you're out. Last one standing wins.",
  ctaLabel: "Take me there",
  ctaPath: "/last-man-standing",
};

export default announcementConfig;
